module.exports = __webpack_public_path__ + "media/my_images/meatan1-ded23060e1d39fb9e0857e6da2f7950b.svg";